import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientForm from "@/pages/ClientForm";
import Quotes from "@/pages/Quotes";
import QuoteForm from "@/pages/QuoteForm";
import QuoteDetail from "@/pages/QuoteDetail";
import Settings from "@/pages/Settings";
import Analytics from "@/pages/Analytics";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090b]">
        <div className="text-zinc-500 text-sm">Carregando...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const Shell = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/" element={<Protected><Dashboard /></Protected>} />
    <Route path="/clientes" element={<Protected><Clients /></Protected>} />
    <Route path="/clientes/novo" element={<Protected><ClientForm /></Protected>} />
    <Route path="/clientes/:id" element={<Protected><ClientForm /></Protected>} />
    <Route path="/cotacoes" element={<Protected><Quotes /></Protected>} />
    <Route path="/cotacoes/nova" element={<Protected><QuoteForm /></Protected>} />
    <Route path="/cotacoes/:id" element={<Protected><QuoteDetail /></Protected>} />
    <Route path="/cotacoes/:id/editar" element={<Protected><QuoteForm /></Protected>} />
    <Route path="/analitico" element={<Protected><Analytics /></Protected>} />
    <Route path="/configuracoes" element={<Protected><Settings /></Protected>} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid #27272a",
                color: "#fafafa",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
